import { Link } from 'react-router-dom';
import { photoSrc } from '../api';
import { timeAgo } from '../format';
import type { Post } from '../types';
import { Avatar } from './Avatar';

export function PostCard({ post, onDelete }: { post: Post; onDelete?: (id: string) => void }) {
  const images = post.media.filter((m) => m.kind === 'image');
  const others = post.media.filter((m) => m.kind !== 'image');
  return (
    <article className="card post">
      <div className="row between">
        <Link to={`/users/${post.author.id}`} className="row" style={{ color: 'inherit' }}>
          <Avatar url={post.author.photoUrl} name={post.author.displayName} size="sm" />
          <div><strong>{post.author.displayName}</strong><div className="muted small">{timeAgo(post.createdAt)}</div></div>
        </Link>
        {post.mine && onDelete && <button className="btn ghost sm" onClick={() => { if (confirm('Delete this post?')) onDelete(post.id); }}>Delete</button>}
      </div>
      {post.body && <p className="post-body">{post.body}</p>}
      {images.length > 0 && (
        <div className={`post-images n${Math.min(images.length, 4)}`}>
          {images.map((m) => <img key={m.id} src={photoSrc(m.url)!} alt="" loading="lazy" width={m.width ?? undefined} height={m.height ?? undefined} />)}
        </div>
      )}
      {others.map((m) => m.kind === 'video'
        ? <video key={m.id} src={photoSrc(m.url)!} controls playsInline preload="metadata" className="post-video" />
        : <audio key={m.id} src={photoSrc(m.url)!} controls preload="metadata" className="post-audio" />)}
    </article>
  );
}
